import { useCallback, useState } from 'react';

/** State + a patch setter that shallow-merges partial updates, for small local view-state objects. */
export function usePatchState<T extends object>(initial: T) {
  const [state, setState] = useState<T>(initial);
  const patch = useCallback((update: Partial<T>) => {
    setState((s) => ({ ...s, ...update }));
  }, []);
  return [state, patch] as const;
}
